export const API_ERROR_MESSAGE_DEFAULT =
  'Something went wrong. Please try again later.'
export const API_ERROR_SSO_REQUIRED = 'Please use Single Sign-On'

export const API_DOWNLOAD_REQUEST_SUCCESS_MESSAGE =
  'An email with a download link will be sent shortly'

export const API_ALREADY_NOTIFIED_RES = 'Already Notified'

export const API_ERROR_MESSAGE = {
  DEFAULT: API_ERROR_MESSAGE_DEFAULT,
  SSO_REQUIRED: API_ERROR_SSO_REQUIRED,
}
export const API_ERROR_CODE = {
  RECORD_OUT_OF_SYNC: 'OUT_OF_SYNC',
  SSO_REQUIRED: 'USER_SSO_ONLY',
}

export const API_ACTION = {
  REMOVE: 'REMOVE',
  ADD: 'ADD',
}
